import { render, staticRenderFns } from "./ViewMultiMessage.vue?vue&type=template&id=0c5094d3&scoped=true&"
import script from "./ViewMultiMessage.vue?vue&type=script&lang=js&"
export * from "./ViewMultiMessage.vue?vue&type=script&lang=js&"
import style0 from "./ViewMultiMessage.vue?vue&type=style&index=0&id=0c5094d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5094d3",
  null
  
)

export default component.exports